module.exports = __webpack_public_path__ + "img/images.79b18a5d.png";